import PropTypes from 'prop-types';
import React from 'react';
import InventoryListingImage from '../InventoryListingImage/index.js';

/**
 *  Molecule to encapsulate `SideBar` content passed from InventoryListing to ItemCard
 */
import { jsx as _jsx } from "react/jsx-runtime";
function InventoryListingSideBar(_ref) {
  let {
    className,
    lazyLoad,
    listing,
    uiContext,
    orientation,
    ...rest
  } = _ref;
  let listingType;
  if (uiContext === 'snapshot') {
    listingType = 'card';
  } else {
    listingType = 'listing';
  }
  return /*#__PURE__*/_jsx(InventoryListingImage, {
    className: className,
    data: listing,
    lazyLoad: lazyLoad,
    orientation: orientation,
    uiContext: listingType,
    withPreviewImages: uiContext === 'simplified',
    ...rest
  });
}
export default InventoryListingSideBar;